import { iframeCommunication } from './iframe-communication';
export function initializeThemeSync() {
    console.log('[theme-sync] Initializing theme synchronization');
    // Get current theme from DOM
    function getCurrentTheme() {
        return document.documentElement.classList.contains('dark') ? 'dark' : 'light';
    }
    // Send current theme to iframe
    function syncThemeToIframe() {
        const currentTheme = getCurrentTheme();
        console.log('[theme-sync] Syncing theme to iframe:', currentTheme);
        // Only send if iframe communication is ready
        if (iframeCommunication.isReady()) {
            iframeCommunication.sendTheme(currentTheme);
        }
        else {
            console.log('[theme-sync] Iframe communication not ready, skipping theme sync');
        }
    }
    // Send initial theme when iframe loads
    function handleIframeLoad() {
        console.log('[theme-sync] Iframe loaded, sending initial theme');
        syncThemeToIframe();
    }
    // Listen for theme changes by observing DOM class changes
    function observeThemeChanges() {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const target = mutation.target;
                    if (target === document.documentElement) {
                        console.log('[theme-sync] Theme changed, syncing to iframe');
                        syncThemeToIframe();
                    }
                }
            });
        });
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['class']
        });
        console.log('[theme-sync] Theme change observer set up');
    }
    // Set up iframe load listener
    const iframe = document.getElementById('playground-iframe');
    if (iframe) {
        iframe.addEventListener('load', handleIframeLoad);
    }
    // Set up theme change observer
    observeThemeChanges();
    console.log('[theme-sync] Theme synchronization initialized');
}
